<template>
    <module-card ref="moduleCard">
        <div class="slot" v-for="(slot, index) in slots" :key="index" ref="slots">
            <p class="text-h6">{{ slot.text }}</p>
            <div class="slot__window">
                <div class="slot__wrap">
                    <div class="slot__item" v-for="(opt, index) in slot.choices" :key="index">{{ opt }}</div>
                    <div class="slot__item slot__item--copy">{{ slot.choices[0] }}</div>
                </div>
            </div>
        </div>

        <template v-slot:actions>
            <v-spacer></v-spacer>
            <v-btn large color="primary" @click="backClick()">Back</v-btn>
            <v-btn large color="primary" @click="shake()">Spin It!</v-btn>
            <v-btn large color="primary" @click="storeChoices()" :disabled="nextDisabled()">{{ nextLabel }}</v-btn>
            <v-spacer></v-spacer>
        </template>
    </module-card>
</template>

<script>
    import { next } from './util';

    export default {
        data() {
            return {
                shaken: false,
                opts: null,
                startedAt: null,
                choices: [],
                nextLabel: 'Next'
            };
        },
        props: {
            id: {
                type: Number,
                required: true
            }
        },
        computed: {
            slots() {
                return this.$store.get(`content@getAClueSlots`);
            }
        },
        methods: {
            storeChoices() {
                this.$store.set(`getAClueChoices@${this.id}.choices`, this.choices);
                this.$refs.moduleCard.nextClick();
            },
            backClick() {
                this.$refs.moduleCard.backClick();
            },
            shake() {
                this.shaken = true;
                this.choices = [];

                if (this.opts) {
                    return;
                }

                this.opts = this.slots.map((data, i) => {
                    const slot = this.$refs.slots[i];
                    const choice = Math.floor(Math.random() * data.choices.length);
                    this.choices.push(choice);
                    // console.log("choice", i, data.choices[choice])

                    const opts = {
                        el: slot.querySelector('.slot__wrap'),
                        finalPos: choice * 50,
                        startOffset: 2000 + Math.random() * 500 + i * 500,
                        height: data.choices.length * 50,
                        duration: 3000 + i * 700, // milliseconds
                        isFinished: false
                    };

                    return opts;
                });

                next(this.animate);
            },
            animate: function (timestamp) {
                if (this.startedAt == null) {
                    this.startedAt = timestamp;
                }

                const timeDiff = timestamp - this.startedAt;

                this.opts.forEach((opt) => {
                    if (opt.isFinished) {
                        return;
                    }

                    const timeRemaining = Math.max(opt.duration - timeDiff, 0);
                    const power = 3;
                    const offset = (Math.pow(timeRemaining, power) / Math.pow(opt.duration, power)) * opt.startOffset;

                    // negative, such that slots move from top to bottom
                    const pos = -1 * Math.floor((offset + opt.finalPos) % opt.height);

                    opt.el.style.visibility = 'visible';
                    opt.el.style.transform = 'translateY(' + pos + 'px)';

                    if (timeDiff > opt.duration) {
                        // console.log('finished', opt, pos, opt.finalPost)
                        opt.isFinished = true;
                    }
                });

                if (this.opts.every((o) => o.isFinished)) {
                    this.opts = null;
                    this.startedAt = null;
                    // console.log('finished')
                } else {
                    next(this.animate);
                }
            },
            nextDisabled() {
                return !this.shaken || this.startedAt != null;
            }
        }
    };
</script>

<style scoped>
    .slot__window {
        width: 100%;
        height: 50px;
        overflow: hidden;

        visibility: hidden;
    }

    .slot__item {
        height: 50px;
        width: 100%;

        text-align: left;
        vertical-align: middle;
    }
</style>
